<template>
  <span class="listing-pdf-span-gtm">
    <a
      class="listing-pdf-gtm"
      @click="isLoggedIn ? downloadPdf() : showAction()"
      v-if="shouldShow"
    >
      PDF
      <svg-icon id="documentText" class="untouched"></svg-icon>
    </a>
    <div class="inner inner--custom" v-if="showLoginDropDown">
      <ul class="listing shortlists shortlists--custom">
        <li class="shortlist-action" @click="showLogin">
          <svg-icon id="signIn"></svg-icon>
          <span>Log In </span>
        </li>
        <li class="shortlist-action" @click="showSignup">
          <svg-icon id="signUp"></svg-icon>
          <span>Sign Up For Free</span>
        </li>
      </ul>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    listing: {
      type: Object,
    },
    selected: {
      type: Array,
    },
  },
  data() {
    return {
      showLoginDropDown: false,
      triggeredAuth: false,
    };
  },
  mounted() {
    window.addEventListener("click", this.delegatedPdf);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.delegatedPdf);
  },
  methods: {
    downloadPdf() {
      window.location.href = "/export/pdf/" + this.listing.slug;
    },
    showLogin() {
      this.triggeredAuth = true;
      this.$store.commit("user/changeAuthMode", "login");
    },
    showSignup() {
      this.triggeredAuth = true;
      this.$store.commit("user/changeAuthMode", "signup");
    },
    showAction() {
      this.showLoginDropDown = !this.showLoginDropDown;
    },
    delegatedPdf(e) {
      let target = e.target;

      while (target.parentNode) {
        if (target === this.$el) {
          return;
        }

        target = target.parentNode;
      }

      this.showLoginDropDown = false;
    },
  },
  computed: {
    authenticating() {},
    shouldShow() {
      return (
        !this.$store.getters["user/account"] ||
        this.$store.getters["user/isHirer"]
      );
    },
    isLoggedIn() {
      var loggedInObj = this.$store.getters["user/account"];
      this.showLoginDropDown =
        typeof loggedInObj === "object" ? false : this.showLoginDropDown;
      return loggedInObj;
    },
  },
  watch: {
    authenticating(now) {
      if (!now && this.triggeredAuth && !this.isLoggedIn) {
        this.triggeredAuth = false;
      }
    },
    isLoggedIn(now) {
      if (now && this.triggeredAuth) {
        this.$store.commit("account/hide");
        this.triggeredAuth = false;
        this.showLoginDropDown = false;
      }
    },
  },
};
</script>
